import { useState } from 'react';
import { InformationIcon } from '../../../../assets/images/countryList';
import './headerCountryList.scss';
const HeaderCountryList = () => {
  const [showInformation, setShowInformation] = useState<boolean>(false);
  return (
    <div id="headerCountryList">
      <div className="boxHedaerCountryList">
        <div className="flagContainer">
          <div className="startHeaderText ml-2.5">País</div>
        </div>
        <div className="rateContainer">
          <div className="startHeaderText">Tasa de cambio</div>
        </div>
        <div className="taxesContainer">
          <div className="startHeaderText">Impuestos</div>
        </div>
        <div className="indicativeContainer">
          <div className="startHeaderText">Indicativo</div>
        </div>
        <div className="documentContainer cursor-pointer">
          <div
            className="startHeaderText"
            onMouseEnter={() => {
              setShowInformation(true);
            }}
            onMouseLeave={() => {
              setShowInformation(false);
            }}
          >
            Tipo de documento fiscal
            <div className="floatInformation">
              <InformationIcon />
              {showInformation && (
                <div className="information">
                  <div className="informationText">
                    <strong>Y:</strong> Alfanumérico
                  </div>
                  <div className="informationText">
                    <strong>X: </strong>Letra
                  </div>
                  <div className="informationText">
                    <strong>0:</strong> Número
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="providerContainer">
          <div className="startHeaderText">Proveedores</div>
        </div>
        <div className="registerContainer">
          <div className="centerHeaderText pr-2">Registro</div>
        </div>
        <div className="extraSpace" />
        <div className="buyContainer">
          <div className="centerHeaderText pr-2">Venta</div>
        </div>
        <div className="extraSpace" />

        <div className="servicesContainer">
          <div className="centerHeaderText pr-2">Servicios</div>
        </div>
        <div className="extraSpace" />
        <div className="storeContainer">
          <div className="centerHeaderText">Bodegas</div>
        </div>
        <div className="saveContainer"></div>
      </div>
    </div>
  );
};

export default HeaderCountryList;
